import { render, staticRenderFns } from "./MvpOffer.vue?vue&type=template&id=3969d40a&scoped=true&"
import script from "./MvpOffer.vue?vue&type=script&lang=js&"
export * from "./MvpOffer.vue?vue&type=script&lang=js&"
import style0 from "./MvpOffer.vue?vue&type=style&index=0&id=3969d40a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969d40a",
  null
  
)

export default component.exports